import { render, staticRenderFns } from "./addTrainee.vue?vue&type=template&id=4166f892&scoped=true"
import script from "./addTrainee.vue?vue&type=script&lang=js"
export * from "./addTrainee.vue?vue&type=script&lang=js"
import style0 from "./addTrainee.vue?vue&type=style&index=0&id=4166f892&prod&lang=css"
import style1 from "./addTrainee.vue?vue&type=style&index=1&id=4166f892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4166f892",
  null
  
)

export default component.exports